import nouislider, { type API, PipsMode, PipsType } from 'nouislider'
import 'nouislider/dist/nouislider.css'
import { SGPlugin } from '../common/SGPlugins'
import '../../../css/no-ui-slider.pcss'

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLElement & {
  noUiSlider: API
}>) => {
  elements.forEach(element => {
    const options = SGPlugin.getElementOptions(element, 'nouislider')

    let tooltips = true
    let pipfilter = 5
    let pipdivisor = 1
    if (options.tooltips === 'false') {
      tooltips = false
    }
    if (options.pipfilter) {
      pipfilter = +options.pipfilter
    }
    if (options.pipdivisor) {
      pipdivisor = +options.pipdivisor
    }
    let pipsConfig: any = {
      mode: PipsMode.Steps,
      density: 2,
      filter: (value: number) => {
        return value % pipfilter ? PipsType.None : PipsType.LargeValue;
      },
      format: {
        to: (value: number) => {
          return value / pipdivisor
        }
      }
    }
    if (options.popularity) {
      pipsConfig = {
        mode: PipsMode.Steps,
        density: 2,
        filter: (value: number) => {
          return [0, 33, 66, 100].includes(value) ? PipsType.LargeValue : PipsType.None;
        },
        format: {
          to: (value: number) => {
            const values = {
              0: 'Все',
              33: 'Популярные',
              66: 'Хиты',
              100: '12/10'
            }
            return values[value]
          }
        }
      }
    }

    nouislider.create(element, {
      range: {
        min: +options.rangemin,
        max: +options.rangemax,
      },
      start: [
        +options.start, +options.end
      ],
      step: +options.step,
      connect: true,
      tooltips: tooltips,
      format: {
        from: (numb) => Math.round(parseFloat(numb)),
        to: (numb) => `${numb}`
      },
      pips: pipsConfig
    })

    element.noUiSlider.on('update', (values, _handleNumber, _unencoded, _tap, locations) => {
      document.querySelector<HTMLSelectElement>(`${options.starthandle}`).value = `${values[0]}`
      document.querySelector<HTMLSelectElement>(`${options.endhandle}`).value = `${values[1]}`
      if (options.gradient) {
        element.style.setProperty('--start-offset', `${locations[0]}`)
        element.style.setProperty('--end-offset', `${locations[1]}`)
      }
    })
    element.noUiSlider.on('start', () => {
      document.body.classList.add('noUi-active-body')
    })
    element.noUiSlider.on('end', () => {
      document.body.classList.remove('noUi-active-body')
    })
    const form = element.closest('form')
    if (form) {
      form.addEventListener('reset', () => {
        element.noUiSlider.reset()
      })
    }
  })
}
